import { EcpLocator } from '../ecp-locator';
// import { Wiki } from '../wiki';
import { SignUpBanner } from '../sign-up-banner';
import { PrimaryBannerUnregistered } from '../primary-banner-unregistered';
import { DownloadApp } from '../../download-app';
import { useStyles } from './landing-page-not-logged-in.styles';
import { Simulator } from '../simulator';
import { KidsBannerUnregistered } from '../kids-banner-unregistered';
import { v2025PP17764 } from '../../../../../constants/veeva';
import { Veeva } from '../../../../common/veeva';

export const LandingPageNotLoggedIn = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <SignUpBanner />
      <DownloadApp />
      <KidsBannerUnregistered />
      <PrimaryBannerUnregistered />
      <EcpLocator isLoggedIn={false} />
      <div className={classes.simulator}>
        <Simulator />
      </div>
      { /* <div className={classes.coloredSection}> */ }
      { /*  <Wiki /> */ }
      { /* </div> */ }
      <Veeva
        veevaNumber={v2025PP17764}
        isRight
        // backgroundColor="#ebfaff"
      />
    </>
  );
};
